module.exports = __webpack_public_path__ + "static/media/bicycles_hero_twitter_card.c9b30d9c.jpg";